'use client';

import { cn } from '@/lib/utils';

interface FiligreeDividerProps {
  direction?: 'left' | 'right';
  className?: string;
  color?: string;
  width?: number;
}

export function FiligreeDivider({
  direction = 'left',
  className,
  color = 'rgba(255, 215, 120, 0.5)',
  width = 36,
}: FiligreeDividerProps) {
  return (
    <svg
      width={width}
      height="10"
      viewBox="0 0 36 10"
      className={cn(
        'inline-block flex-shrink-0',
        direction === 'right' && 'scale-x-[-1]',
        className,
      )}
      aria-hidden
    >
      <line x1="0" y1="5" x2="18" y2="5" stroke={color} strokeWidth="0.75" />
      <path
        d="M18 5 L22 2 L26 5 L22 8 Z"
        fill="none"
        stroke={color}
        strokeWidth="0.75"
      />
      <circle cx="30" cy="5" r="1" fill={color} />
      <line x1="32" y1="5" x2="36" y2="5" stroke={color} strokeWidth="0.75" />
    </svg>
  );
}
